import config from "../config"
const baseUrl = config.base_url + "container_indicator_pest_disease/"
export default {
    save: {
        url: baseUrl + "save",
        type: "post",
    },
    listByIndicatorId: {
        url: baseUrl + "listByIndicatorId",
        type: "get",
    },
    listByIndicatorIds: {
        url: baseUrl + "listByIndicatorIds",
        type: "get",
    },
    listIndicatorIdsByPestDiseaseId: {
        url: baseUrl + "listIndicatorIdsByPestDiseaseId",
        type: "get",
    },
    listPestDiseaseIdsByIndicatorId: {
        url: baseUrl + "listPestDiseaseIdsByIndicatorId",
        type: "get",
    },
    deleteByIndicatorId: {
        url: baseUrl + "deleteByIndicatorId",
        type: "get",
    },
    deleteByPestDiseaseId: {
        url: baseUrl + "deleteByPestDiseaseId",
        type: "get",
    },
    listPestDiseaseOptions: {
        url: baseUrl + "listPestDiseaseOptions",
        type: "get",
    }
}
